import { createContext, useContext, useEffect, useState, useCallback } from 'react';

const WishlistContext = createContext(null);
const KEY = 'evermark-wishlist-v1';

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => {
    if (typeof window === 'undefined') return [];
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  const toggle = useCallback((slug) => {
    setIds((prev) => (prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug]));
  }, []);
  const has = useCallback((slug) => ids.includes(slug), [ids]);
  const remove = useCallback((slug) => setIds((prev) => prev.filter((s) => s !== slug)), []);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, remove, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
